module.exports = __webpack_public_path__ + "6b265efbbb73dae632cbca6583f507ca.png";